import React, {Component} from "react";
import "../../../profile/container/profile/css/main-profile.min.css";
import "../../../project/container/Project/css/main-projects.min.css";
import "react-toastify/dist/ReactToastify.css";
import {authService} from "../../../auth";
import {Link, NavLink} from "react-router-dom";
import Header from "../../../Header";
import LeftPanel from '../../../LeftPanel';
import StaticHeader from "../../../StaticHeader";
import $ from "jquery";
import AuthModalComponent from "../../../LoginExtra/AuthModalComponent";
import SignUpModal from "../../../SignUpModal/signUpModal";
import LeftPanelUnauth from "../../../commons/LeftPanelUnauth";

class PrivateProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
        };

    }

    loginRequired=(slug)=> {
        this.setState({'loginRequired': true, 'pathname':slug})
        window.$('#loginModal').modal('show');
    }
    handleLoginClose = () => {
        this.setState({'loginRequired': false})
        window.$('#loginModal').modal('hide');
    }
    componentDidMount() {
        window.$(".unauthLoginPopclose").click(function(){
            window.$(".bkbackdrop2").hide();
        });

        window.$('#header .iCross').hide();
        window.$("#header .iHamburger").on('click', function (event) {
            window.$('.leftpanel').addClass('navactive');
            window.$('.dgcontainer').addClass('navactive');
            window.$('.staticPage').addClass('navactive');
            window.$('#header .iHamburger').hide();
            window.$('#header .iCross').show();
        });
        $("body, html").on('click', function (event) {
            if (!$(event.target).closest('#header .iHamburger, .read-more-less-btn').length) {
                $('.leftpanel').removeClass('navactive');
                $('.dgcontainer').removeClass('navactive');
                window.$('.staticPage').removeClass('navactive');
                $('.dropdown-menu.show').removeClass('show');
                window.$('#header .iHamburger').show();
                window.$('#header .iCross').hide();
            }
        });
        window.$('.usermenu .dropdown-submenu > a').on("click", function (e) {
            var submenu = $(this);
            $('.usermenu .dropdown-submenu .dropdown-menu').removeClass('show');
            submenu.next('.usermenu .dropdown-menu').addClass('show');
            e.stopPropagation();
        });
    }

    signUpRequired=()=>{
        this.setState({'signUpRequired':true})
        window.$('#signupModal').modal('show');
    }

    handleSignUpClose = () => {
        this.setState({'signUpRequired': false})
        window.$('#signupModal').modal('hide');
    }


    render() {

            return <div className={'staticPage'}>
        <div className="wrapper projectpage nologinpage">

                {!this.state.loginSuccess ? <StaticHeader/> : <Header/> } 
                <main className="dgcontainer hm3col">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                {/* <div className="bk_dactiveprflbx">
                                    <img src="https://cdn.dscovr.com/images/Deactivated.webp" onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/Deactivated.png"}} alt=""/>
                                    <p>This account has been kept private by the member!</p>
                                    <Link to={"explore"} className="btn connect_btn">Explore More <i
                                        className="iArrow_Right"/></Link>
                                </div> */}
                                <div className="bk_dactiveprflbx privateUser">
                                    <img src="https://cdn.dscovr.com/images/HiddenProfileImg.png" alt=""/> 
                                    <h3>Contents restricted<br/> due to Privacy Settings</h3>                       
                                    <p><Link to={"/signup"}>Signup</Link> to look at this content</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                {!this.state.loginSuccess ?
                    <LeftPanelUnauth signUpRequired={this.signUpRequired}/> :
                <LeftPanel/>} 
            {this.state.loginRequired === true ? <AuthModalComponent handleLoginClose={this.handleLoginClose} pathname={this.state.pathname} history={this.props.history}/> : null}
            {this.state.signUpRequired === true ? <SignUpModal  handleSignUpClose={this.handleSignUpClose} history={this.props.history}/> : null}
        </div></div>

    }

}

export default PrivateProfile

